<template>
  <div
    v-if="element"
    class="multi-input-selector padding-top"
  >
    <div
      class="mode-button"
      @click="EventChange"
    >
      <img
        :src="element.iconButton"
        :alt="element.altButton"
        class="button-icon"
      >
    </div>

    <UCSearchEntityERP
      ref="searchEntityRef"
      class="search-entity-erp"
      :placeholder="element.placeholder"
      :qr-search-show="true"
      :qr-search-params="element.qrSearchParams"
      :search-text="element.searchText"
      :min-text-search="element.minTextSearch"
      :search-cancellation-text="element.searchCancellationText"
      :search-not-found-text="element.searchNotFoundText"
      :property-entity-shown-input="element.propertyEntityShownInput"
      :property-entity-shown-list-title="element.propertyEntityShownListTitle"
      :property-entity-shown-list-subtitle="element.propertyEntityShownListSubtitle"
      :procedure-for-search="element.procedureForSearch"
      @selection="handleSelection"
    />
  </div>
</template>

<script setup>
// @ts-check
import { computed, ref, shallowRef } from 'vue';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';

/** @import { PropType, ShallowRef } from 'vue' */
/** @typedef {InstanceType<typeof UCSearchEntityERP>['$props'] & {
 * iconButton: string;
 * altButton: string
 * }} MultiSearchEntitySelectorConf */

const props = defineProps({
  conf: {
    type: /** @type {PropType<MultiSearchEntitySelectorConf[]>} */ (Array),
    required: true,
  },
  // Permite utilizar el botón de cambio entre input.
  allowChange: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits([
  'change',
  'selection',
]);

/** @type {ShallowRef<InstanceType<typeof UCSearchEntityERP> | null>} */
const searchEntityRef = shallowRef(null);

// Índice actual en la configuración
const confIndex = ref(0);
const element = computed(() => props.conf[confIndex.value]);

/** Evento de lectura de código de barras. */
function EventChange() {
  if (!props.allowChange) {
    return;
  }

  confIndex.value = (confIndex.value + 1) % props.conf.length;
  clear(); // Limpiar el campo de entrada al cambiar el modo
  emit('change', element.value);
}

/**
 * @param {Record<string, any>} obj
 * @returns {void}
 */
function handleSelection(obj) {
  emit('selection', obj);
}

/**
 * Clears the selected data.
 * @public
 * @returns {void}
 */
function clear() {
  searchEntityRef.value?.Clear();
}

defineExpose({
  clear,
});
</script>

<style lang="scss">
.multi-input-selector {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
  background: var(--his-slate-blue);

  .mode-button {
    border: 1px solid var(--his-silver);
    background: var(--his-tierra-white);
    text-align: center;
    border-radius: 8px;
    margin-left: 8px;
    margin-bottom: 8px;
    padding-top: 8px;
    padding-bottom: 1px;
    padding-right: 10px;
    padding-left: 10px;
    cursor: pointer;

    .button-icon {
      width: 30px;
      height: 30px;
    }
  }

  .search-entity-erp {
    margin-left: 8px;
    width: 100%;
    margin-bottom: 8px;
  }
}
</style>
